import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Reusable loading spinner component
 * Can be used as a standalone spinner or as an inline spinner in buttons
 */
const LoadingSpinner = ({ small = false, centered = true }) => {
  if (small) {
    return (
      <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        className="me-1"
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }
  
  return (
    <div className={`d-flex ${centered ? 'justify-content-center' : ''} my-4`}>
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

LoadingSpinner.propTypes = {
  small: PropTypes.bool,
  centered: PropTypes.bool
};


export default LoadingSpinner;
